import { ptBrCommon } from '@/lib/pt-br/messages';

interface ErrorProps {
  message?: string;
}

/** Inline field-level error text (named to avoid shadowing the global Error). */
export const FieldError: React.FC<ErrorProps> = ({ message }) => {
  return (
    <p className="mt-2 text-xs text-red-500 ltr:text-left rtl:text-right">
      {ptBrCommon(message!)}
    </p>
  );
};

const ErrorMessage: React.FC<ErrorProps> = ({ message }) => {
  return (
    <p className="max-w-sm p-5 mx-auto mt-16 text-lg font-semibold text-center bg-red-400 rounded min-w-min text-light">
      {ptBrCommon(message!)}
    </p>
  );
};

export default ErrorMessage;
